<template>
  <div class="big">
    <el-dialog
      title="新建成药"
      :visible.sync="dialogShow"
      width="1000px"
      style="text-align: left"
      class="pm-index"
      top="50px"
      :close-on-click-modal="false"
      @close="close"
    >
      <div class="content">
        <el-form
          :model="ruleForm"
          :inline="true"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm myform"
        >
          <div class="itemtitle">药房名称</div>
          <el-form-item label="选择药房" prop="hospital_id">
            <el-select v-model="ruleForm.hospital_id" class="myinput">
              <el-option
                v-for="(item, index) in hospitalList"
                :key="index"
                :label="item.hospital_name"
                :value="item.hospital_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="itemtitle">成药属性</div>
          <el-form-item label="成药编号">
            <el-input
              v-model="ruleForm.pm_code"
              placeholder="请输入"
              maxlength="20"
              class="myinput"
            ></el-input>
          </el-form-item>
          <el-form-item label="成药名称" prop="pm_name">
            <el-input
              v-model="ruleForm.pm_name"
              placeholder="请输入"
              class="myinput"
            ></el-input>
          </el-form-item>

          <div style="display: inline-block">
            <el-form-item label="规格" prop="pm_spec">
              <el-input
                v-model="ruleForm.pm_spec"
                placeholder="请输入"
                class="myinput"
                style="width: 120px"
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="">
              <el-input-number
                class="myinput"
                v-model="ruleForm.total_measurement_units"
                :min="0"
                :step="1"
                :controls="false"
                style="width: 108px; margin-right: 4px"
                placeholder="计量单位总量"
              ></el-input-number>
              <el-input
                class="myinput"
                v-model="ruleForm.min_unit_total_quantity"
                style="width: 108px"
                placeholder="最小单位总量"
              ></el-input>
            </el-form-item>
          </div>

          <el-form-item label="单位" prop="pm_unit">
            <el-input
              v-model="ruleForm.pm_unit"
              placeholder="请输入"
              class="myinput"
            ></el-input>
          </el-form-item>

          <el-form-item label="建议用量" prop="default_use_level">
            每次
            <el-input-number
              v-model="ruleForm.default_use_level"
              placeholder="请输入数量"
              style="width: 200px; margin-right: 10px; text-align: left"
              :min="1"
              :controls="false"
              :precision="1"
            ></el-input-number>

            <el-input
              v-model="ruleForm.use_level_unit"
              placeholder="请输入单位"
              style="width: 110px"
            ></el-input>
          </el-form-item>

          <el-form-item label="服用频次" prop="frequency_of_use">
            <el-select
              v-model="ruleForm.frequency_of_use"
              placeholder="请选择"
              clearable
              style="width: 350px"
            >
              <el-option
                v-for="item in frequencyOptions"
                :key="item.id"
                :label="item.frequency_of_use"
                :value="item.frequency_of_use"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="cost_price" label="成本价">
            <el-input
              v-model="ruleForm.cost_price"
              placeholder="请输入"
              class="myinput"
            >
              <span slot="suffix">元</span>
            </el-input>
          </el-form-item>

          <el-form-item prop="price" label="销售价">
            <el-input
              v-model="ruleForm.price"
              placeholder="请输入"
              class="myinput"
            >
              <span slot="suffix">元</span>
            </el-input>
          </el-form-item>

          <el-form-item label="成药分类" prop="pm_category">
            <el-select
              v-model="ruleForm.pm_category"
              placeholder="请选择"
              style="width: 350px"
            >
              <el-option label="西药" value="1"></el-option>
              <el-option label="中成药" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="生产厂家" prop="productor">
            <el-input
              v-model="ruleForm.productor"
              placeholder="请输入"
              maxlength="50"
              class="myinput"
            ></el-input>
          </el-form-item>

          <el-form-item label="疗效分类" prop="category_id">
            <el-select
              v-model="ruleForm.category_id"
              placeholder="请选择"
              style="width: 350px"
            >
              <el-option
                v-for="(item, index) in categoryList"
                :key="index"
                :label="item.category_name"
                :value="item.category_id"
                :disabled="item.is_visible == 0"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="默认用法" prop="default_use_method">
            <el-input
              v-model="ruleForm.default_use_method"
              placeholder="请输入"
              maxlength="50"
              class="myinput"
            ></el-input>
          </el-form-item>

          <el-form-item label="贮藏" prop="default_storage">
            <el-input
              v-model="ruleForm.default_storage"
              placeholder="请输入"
              maxlength="50"
              class="myinput"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="功能主治"
            prop="functional_indications"
            class="functional_indications"
          >
            <el-input
              v-model="ruleForm.functional_indications"
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              maxlength="200"
              show-word-limit
              style="width: 810px"
            ></el-input>
          </el-form-item>

          <div class="itemtitle">药品图片</div>
          <el-form-item
            label=""
            class="icon_img"
            style="display: block; height: 160px"
            prop="pic"
          >
            <upload-img @emitImg="emitImg"></upload-img>
          </el-form-item>

          <div class="itemtitle">说明书信息</div>
          <div class="editor-box">
            <Editor ref="editorBox"></Editor>
          </div>
          <div class="itemtitle">库存信息</div>
          <el-form-item label="理论库存">
            <el-input-number
              class="myinput"
              v-model="ruleForm.stock"
              :min="0"
              :max="999999"
              :controls="false"
              step-strictly
            ></el-input-number>
          </el-form-item>
          <el-form-item prop="stock_warning" label="库存预警值">
            <el-input-number
              class="myinput"
              v-model="ruleForm.stock_warning"
              :min="0"
              :max="999999"
              :controls="false"
              step-strictly
            ></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div
        style="
          text-align: right;
          padding: 0 58px 10px 0;
          box-sizing: border-box;
        "
      >
        <el-button @click="close" style="width: 92px" size="medium"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="submit"
          style="width: 92px"
          size="medium"
          >提 交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Editor from "../../../components/common/Editor";
import UploadImg from "../../../components/uploadImg";
export default {
  name: "addDrugs",
  components: {
    Editor,
    UploadImg,
  },
  data() {
    let checkCostPrice = (rule, value, callback) => {
      if (value != "") {
        if (this.ruleForm.cost_price != "") {
          // if (Number(value) <= Number(this.ruleForm.cost_price)) {
          //   callback(new Error("销售价须大于成本价"));
          // } else {
          //   callback();
          // }
          callback();
        } else {
          callback();
        }
        callback();
      } else {
        callback();
      }
    };
    let checkPrice = (rule, value, callback) => {
      if (value != "") {
        if (this.ruleForm.price != "") {
          if (Number(value) >= Number(this.ruleForm.price)) {
            callback(new Error("成本价须小于销售价"));
          } else {
            callback();
          }
        } else {
          callback();
        }
        callback();
      } else {
        callback();
      }
    };
    const validateSuggestedDosage = (rule, value, callback) => {
      const form = this.ruleForm;
      const dosage = form.default_use_level;
      const unit = form.use_level_unit;
      // 如果两个字段都为空，不验证（通过）
      if (!dosage && !unit) {
        callback();
        return;
      }

      // 如果其中一个有值但另一个为空，则报错
      if ((dosage && !unit) || (!dosage && unit)) {
        callback(new Error("请填写建议用量和单位"));
      } else {
        callback();
      }
    };
    return {
      dialogShow: true,
      loading: false,
      hospitalList: [],
      ruleForm: {
        hospital_id: "",
        pm_id: "",
        pm_code: "",
        pm_name: "",
        pm_spec: "",
        pm_unit: "",
        cost_price: "",
        price: "",
        weight: 1,
        stock: undefined,
        productor: "",
        default_use_method: "",
        default_storage: "",
        pm_category: "",
        stock_warning: undefined,
        category_id: "",
        pm_thumb: "",
        pm_thumb_str: "",
        default_use_level: undefined,
        use_level_unit: "",
        total_measurement_units: undefined,
        min_unit_total_quantity: undefined,
        frequency_of_use: "",
        functional_indications: "",
      },
      medicineUseList: [],
      drug_remote_list: [],
      frequencyOptions: [],
      categoryList: [],
      rules: {
        hospital_id: [
          { required: true, message: "请选择药房", trigger: "blur" },
        ],
        pm_code: [
          { required: true, message: "请输入成药编号", trigger: "blur" },
        ],
        pm_unit: [
          { required: true, message: "请输入成药单位", trigger: "blur" },
        ],
        pm_spec: [
          { required: true, message: "请输入成药规格", trigger: "blur" },
        ],
        pm_name: [
          { required: true, message: "请输入成药名字", trigger: "blur" },
        ],
        pm_category: [
          { required: true, message: "请选择成药分类", trigger: "blur" },
        ],
        category_id: [
          { required: true, message: "请选择疗效分类", trigger: "blur" },
        ],
        productor: [
          { required: true, message: "请输入生产厂家", trigger: "blur" },
        ],
        price: [
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,4})?$/,
            message: "请输入4位小数以内数字",
            trigger: ["blur", "change"],
          },

          { required: true, message: "请输入销售价", trigger: "blur" },
        ],
        cost_price: [
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,4})?$/,
            message: "请输入4位小数以内数字",
            trigger: ["blur", "change"],
          },

          { required: true, message: "请输入成本价", trigger: "blur" },
        ],
        // default_use_level: [
        //   {
        //     validator: validateSuggestedDosage,
        //     trigger: "blur",
        //   },
        // ],
      },
    };
  },
  created() {
    this.getPmFromData();
    this.getMedicineOintmentCategory();
    this.getHospital();
  },

  methods: {
    // 获取图片
    emitImg(data) {
      this.ruleForm.pm_thumb = data.pic;
      this.ruleForm.pm_thumb_str = data.path;
    },
    // 成药服用频次
    getPmFromData() {
      this.axios
        .post("platform/Goods/getPmFromData")
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.frequencyOptions = data.list;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //提交
    submit() {
      let checked = false;
      this.$refs.ruleForm.validate((valid) => {
        checked = valid;
      });
      if (!checked) {
        return;
      }
      let data = {
        hospital_id: this.ruleForm.hospital_id,
        pm_code: this.ruleForm.pm_code,
        pm_name: this.ruleForm.pm_name,
        pm_spec: this.ruleForm.pm_spec,
        pm_unit: this.ruleForm.pm_unit,
        price: this.ruleForm.price,
        cost_price: this.ruleForm.cost_price,
        productor: this.ruleForm.productor,
        default_use_method: this.ruleForm.default_use_method,
        default_storage: this.ruleForm.default_storage,
        weight: this.ruleForm.weight,
        stock: this.ruleForm.stock,
        category_id: this.ruleForm.category_id,
        pm_category: this.ruleForm.pm_category,
        stock_warning: this.ruleForm.stock_warning,
        stock_opening: this.ruleForm.stock_opening,
        content: this.$refs.editorBox.editor.txt.html(),
        pm_thumb: this.ruleForm.pm_thumb,
        default_use_level: this.ruleForm.default_use_level,
        use_level_unit: this.ruleForm.use_level_unit,
        frequency_of_use: this.ruleForm.frequency_of_use,
        total_measurement_units: this.ruleForm.total_measurement_units,
        min_unit_total_quantity: this.ruleForm.min_unit_total_quantity,
        functional_indications: this.ruleForm.functional_indications,
      };
      this.axios
        .post("platform/Goods/submitHospitalMedicine", data)
        .then((res) => {
          this.$message.success("提交成功");
          this.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取疗效分类
    getMedicineOintmentCategory() {
      let data = { type: 2 };
      this.axios
        .post("platform/Goods/getMedicineOintmentCategory", data)
        .then((res) => {
          this.categoryList = res.data.list;
        });
    },
    //获取药房列表
    getHospital() {
      this.axios
        .post("platform/hospital/getHospitaList", {
          page: 1,
          pageNumber: 1000,
          is_pm: 1,
        })
        .then((res) => {
          this.hospitalList = res.data.list;
        });
    },
    //关闭
    close() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style lang="scss" scoped>
.myform {
  padding: 20px 30px;
  box-sizing: border-box;
  .functional_indications {
    ::v-deep .el-form-item__content {
      height: auto;
    }
  }
}
.editor-box {
  position: relative;
  width: 100%;
  height: 500px;
  .editor {
    width: 100%;
    position: absolute;
    z-index: 999;
    top: -20px;
    left: 0;
  }
}
.itemtitle {
  font-size: 16px;
  color: #333;
  font-weight: 600;
  margin-bottom: 24px;
}
.myinput {
  width: 350px;
}
.content {
  height: 75vh;
  overflow: auto;
}
.medicine-table {
  margin-bottom: 20px;
  width: 910px;
  .top {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid #c4cbd9;
    background-color: #f6f6f6;
    line-height: 40px;
    padding-left: 10px;
    font-weight: 600;
  }
}
.medicine-info {
  margin-top: 10px;
  padding: 5px;
  padding-left: 10px;
  border-radius: 2px;
  border: solid 1px #c4cbd9;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  height: 40px;
  font-size: 12px;
  div {
    margin: 0 10px;
  }
  .el-input-number {
    width: 60px;
  }
}
</style>
<style lang="scss">
.medicine-box {
  .item {
    border: 1px solid #c4cbd9;
    width: 303px;
    box-sizing: border-box;
    &:nth-of-type(3n + 2),
    &:nth-of-type(3n + 3) {
      border-left: none;
    }
    &:nth-of-type(n + 4) {
      border-top: none;
    }
    .name-input {
      flex: 1;
      input {
        border-radius: 0%;
        border-color: transparent;
        &:focus {
          border-color: #1890ff;
        }
      }
    }
    .count-input {
      width: 70px;
      margin-right: 5px;
      .el-input {
        width: 30px;
        margin-right: 10px;
      }
      &.max input {
        border: 1px solid #ff514b;
      }
      input {
        border-radius: 0%;
        padding: 0;
        padding-left: 10px;
        box-sizing: border-box;
      }
    }
    .use-input {
      width: 80px;
      margin-right: 5px;
      input {
        border-radius: 0%;
      }
    }
  }
}
</style>
